import { render } from "./ProductItem.vue?vue&type=template&id=f3e0ceb8&scoped=true&bindings={}"
import script from "./ProductItem.vue?vue&type=script&lang=ts"
export * from "./ProductItem.vue?vue&type=script&lang=ts"

import "./ProductItem.vue?vue&type=style&index=0&id=f3e0ceb8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-f3e0ceb8"

export default script